import { FramingSelections } from '../../../components/Checkout/Framing/types';
import { GeneratedDrawType } from '../../../types/generated';
import { TrackEvent } from '../../../utils/analytics';
import { AvailableDraw } from '../../draws/types';

const DRAW_ENTRY_EVENT = 'draw_entry';
const ENTRY_SUCCESS_EVENT = 'draw review entry success';

export type CheckoutEntrySuccessArgs = {
  artistId?: string;
  drawType?: GeneratedDrawType;
  framingSelections: FramingSelections;
  isPreOrder: boolean;
  intentId: string | null;
  preOrderOptIn: boolean;
  selectedEntries: AvailableDraw[];
  user?: { email?: string | null; id?: string | null } | null;
};

const joinValues = (values: (string | null | undefined)[]): string => {
  return values.filter(Boolean).join(',');
};

export const buildEntrySuccessProperties = ({
  artistId,
  drawType,
  framingSelections,
  intentId,
  isPreOrder,
  preOrderOptIn,
  selectedEntries,
  user,
}: CheckoutEntrySuccessArgs) => {
  const drawIds = joinValues(selectedEntries.map((entry) => entry.draw.id));

  return {
    'type': drawType,
    'artist_id': artistId,
    ...(isPreOrder
      ? {
          'preorder_application_count': 1,
          'public_preorder_ids': drawIds,
        }
      : {
          'draw_entry_count': 1,
          'public_draw_id': drawIds,
          'isFramed': selectedEntries.some((entry) => {
            return Boolean(framingSelections[entry.product.shopifyId]);
          }),
        }),
    'draw_intent_id': intentId,
    'product_id': joinValues(selectedEntries.map((entry) => entry.product.id)),
    'product_name': joinValues(
      selectedEntries.map((entry) => entry.product.title),
    ),
    'pre-order opt in': preOrderOptIn,
    'user_email': user?.email,
    'user_id': user?.id,
  };
};

export const trackCheckoutEntrySuccess = (args: CheckoutEntrySuccessArgs) => {
  const properties = buildEntrySuccessProperties(args);

  TrackEvent(DRAW_ENTRY_EVENT, properties);
  TrackEvent(ENTRY_SUCCESS_EVENT, properties);
};
